import { createI18n } from 'vue-i18n'
import en from './en.json'
import zh_Hant from './zh_Hant.json'
import ja from './ja.json'
import ko from './ko.json'
import de from './de.json'
import it from './it.json'
import pt from './pt.json'
import fr from './fr.json'
import es from './es.json'
import ar from './ar.json'

// 英语、繁体中文、日语、韩语、德语、意大利语、葡萄牙语、法语、西班牙语、阿拉伯语
export const SUPPORTED_LOCALES: string[] = ['en', 'zh_Hant', 'ja', 'ko', 'de', 'it', 'pt', 'fr', 'es', 'ar']

const i18n = createI18n({
  locale: 'en', // 初始语言
  legacy: false,
  fallbackLocale: 'en',
  messages: {
    en,
    zh_Hant,
    ja,
    ko,
    de,
    it,
    pt,
    fr,
    es,
    ar,
  }
})

export default i18n